import PropTypes from 'prop-types';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import Filter from '../../../../Filters/Filter';
import LayoverSlider from './LayoverSlider';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';
import { flightSearch } from '../../../../../store/slices/flight';

const LayoverFlightFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { track } = useAnalytics();
  const dispatch = useDispatch();
  const isTripSearch = !tripId;

  const { searchObj, defaultSearchObj } = useSelector(flightSearchInput(tripId, isTripSearch));

  const doShowFilter =
    defaultSearchObj.filterTimeLayoverMax &&
    defaultSearchObj.filterTimeLayoverMin &&
    searchObj.filterTimeLayoverStart &&
    searchObj.filterTimeLayoverEnd;

  if (!doShowFilter) return <></>;

  const isEmpty =
    searchObj.filterTimeLayoverStart === defaultSearchObj.filterTimeLayoverMin &&
    searchObj.filterTimeLayoverEnd === defaultSearchObj.filterTimeLayoverMax;

  const search = (o) => {
    const payload = {
      tripId,
      searchObj: {
        ...o,
        page: 1,
      },
    };

    if (isTripSearch) {
      dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
      dispatch(flightSearch({ isTripSearch: true, ...payload.searchObj }));
    } else dispatch(flightSearch(payload));
    track('LayoverFlightFilter.search', {
      searchObj: JSON.stringify(o),
    });
  };

  const handleChangeLayover = (event, newValue) => {
    search({
      filterTimeLayoverStart: newValue[0],
      filterTimeLayoverEnd: newValue[1],
    });
  };

  const handleClear = () => {
    search({
      filterTimeLayoverStart: defaultSearchObj.filterTimeLayoverMin,
      filterTimeLayoverEnd: defaultSearchObj.filterTimeLayoverMax,
    });
  };

  return (
    <Filter
      label="Filter by Layover"
      menuWidthClass="w-max"
      isFilterEmpty={isEmpty}
      variant={variant}
      filterMaxWidthClass="max-w-full"
      filterSpacingClass={filterSpacingClass}
      handleClear={handleClear}
      bgClassName={!isTripSearch ? '' : undefined}
    >
      <div className="px-4 pb-1 pt-4">
        <LayoverSlider
          layover={[searchObj.filterTimeLayoverStart, searchObj.filterTimeLayoverEnd]}
          layoverMax={defaultSearchObj.filterTimeLayoverMax}
          layoverMin={defaultSearchObj.filterTimeLayoverMin}
          onLayoverChange={handleChangeLayover}
        />
      </div>
    </Filter>
  );
};

LayoverFlightFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};
LayoverFlightFilter.defaultProps = {
  tripId: undefined,
  variant: undefined,
  filterSpacingClass: undefined,
};

export default memo(LayoverFlightFilter);
